import { render } from "./StaticLeadData.vue?vue&type=template&id=56a06524&scoped=true"
import script from "./StaticLeadData.vue?vue&type=script&lang=js"
export * from "./StaticLeadData.vue?vue&type=script&lang=js"

import "./StaticLeadData.vue?vue&type=style&index=0&id=56a06524&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a06524"]])

export default __exports__